/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeFollowRequest } from "../models/MeFollowRequest";
import type { MeFollowResponseApiRespoonse } from "../models/MeFollowResponseApiRespoonse";
import type { MeisLikeAlbumRequest } from "../models/MeisLikeAlbumRequest";
import type { MeisLikeAlbumResponseApiRespoonse } from "../models/MeisLikeAlbumResponseApiRespoonse";
import type { MeLikeAlbumRequest } from "../models/MeLikeAlbumRequest";
import type { MeLikeAlbumResponseApiRespoonse } from "../models/MeLikeAlbumResponseApiRespoonse";
import type { MeLikeArticleRequest } from "../models/MeLikeArticleRequest";
import type { MeLikeArticleResponseApiRespoonse } from "../models/MeLikeArticleResponseApiRespoonse";
import type { MeListGroupRequest } from "../models/MeListGroupRequest";
import type { MeListGroupResponseApiRespoonse } from "../models/MeListGroupResponseApiRespoonse";
import type { MemberManagerUpdateProfileRequest } from "../models/MemberManagerUpdateProfileRequest";
import type { MemberManagerUpdateProfileResponseApiRespoonse } from "../models/MemberManagerUpdateProfileResponseApiRespoonse";
import type { MeProfileRequest } from "../models/MeProfileRequest";
import type { MeProfileResponseApiRespoonse } from "../models/MeProfileResponseApiRespoonse";
import type { MeTotalFollowedGroupRequest } from "../models/MeTotalFollowedGroupRequest";
import type { MeTotalFollowedGroupResponseApiRespoonse } from "../models/MeTotalFollowedGroupResponseApiRespoonse";
import type { MeUpdateDeviceTokenRequest } from "../models/MeUpdateDeviceTokenRequest";
import type { MeUpdateDeviceTokenResponseApiRespoonse } from "../models/MeUpdateDeviceTokenResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class MeService {
  /**
   * タグ一覧
   * @param requestBody
   * @returns MeListGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meGroups(
    requestBody: MeListGroupRequest
  ): CancelablePromise<MeListGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/me/groups",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Follow
   * @param requestBody
   * @returns MeFollowResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meFollow(
    requestBody: MeFollowRequest
  ): CancelablePromise<MeFollowResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/me/follow",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Follow
   * @param requestBody
   * @returns MeProfileResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meProfile(
    requestBody: MeProfileRequest
  ): CancelablePromise<MeProfileResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/me/profile",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Follow
   * @param requestBody
   * @returns MeLikeArticleResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meLike(
    requestBody: MeLikeArticleRequest
  ): CancelablePromise<MeLikeArticleResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/me/like",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * like/dislike alnum
   * @param requestBody
   * @returns MeLikeAlbumResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meLikeAlbum(
    requestBody: MeLikeAlbumRequest
  ): CancelablePromise<MeLikeAlbumResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/me/like-album",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * check album is liked by member
   * @param requestBody
   * @returns MeisLikeAlbumResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meIsLikeAlbum(
    requestBody: MeisLikeAlbumRequest
  ): CancelablePromise<MeisLikeAlbumResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/me/is-like-album",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * count group that member followed
   * @param requestBody
   * @returns MeTotalFollowedGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meTotalFollowedGroup(
    requestBody: MeTotalFollowedGroupRequest
  ): CancelablePromise<MeTotalFollowedGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/me/total-followed-group",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Update profile by member
   * @param requestBody
   * @returns MemberManagerUpdateProfileResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meUpdateProfile(
    requestBody: MemberManagerUpdateProfileRequest
  ): CancelablePromise<MemberManagerUpdateProfileResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/me/update-profile",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Update device token
   * @param requestBody
   * @returns MeUpdateDeviceTokenResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meUpdateDeviceToken(
    requestBody: MeUpdateDeviceTokenRequest
  ): CancelablePromise<MeUpdateDeviceTokenResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/me/update-device-token",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
